<template>
  <div>
      当前页面不存在，请检查网址是否正确
      <div>
          <router-link to="/">返回首页</router-link>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>